import { render, staticRenderFns } from "./admin-menu.vue?vue&type=template&id=19fb36d9&"
import script from "./admin-menu.component.ts?vue&type=script&lang=ts&"
export * from "./admin-menu.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports